import { render, staticRenderFns } from "./TopicSelect.vue?vue&type=template&id=315ba912"
import script from "./TopicSelect.vue?vue&type=script&lang=js"
export * from "./TopicSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports